import { ListHeaderCounter, ListHeaderTitle, ListHeaderTitleContainer } from '@/components/List'

import { useTexts } from '../../../../useTexts'
import { useTitle } from './hooks/useTitle'

export function Title() {
  const { editing, selection, listStructure, onSelectAll, noEntries } = useTitle()

  const texts = useTexts()

  return (
    <ListHeaderTitleContainer>
      <ListHeaderTitle>{texts.driverAssignments}</ListHeaderTitle>

      <ListHeaderCounter
        allSelected={selection.length >= listStructure.shownItems}
        disabled={editing}
        readonly={noEntries}
        onClick={onSelectAll}
      >
        {listStructure.shownItems}
      </ListHeaderCounter>
    </ListHeaderTitleContainer>
  )
}
